module.exports = __webpack_public_path__ + "img/halloween_candy.9761bd18.svg";